
import './BootstrapDemo.css';
import React, { useRef, useEffect } from 'react';
// najpierw zainstalować bibliotekę bootstrap:
// npm install bootstrap
import 'bootstrap/dist/css/bootstrap.css';

export default function BootstrapDemo() {
const myBtnRef = useRef(null);  //referencja do Button
//let myBtn = document.getElementById("btn");
const myLoremRef = useRef(null);  //referencja do Lorem Ipsum
//let myLorem = document.getElementById("lorem");
//let myClassOld = "text-body";
const myClass = useRef(null);
const myClassOld = useRef("text-body");
//let myClass = "";
const patternIndexRef = useRef(0);
//let patternIndextab = [];
const t1Ref = useRef(null);
const t2Ref = useRef(null);
const t3Ref = useRef(null);
const t4Ref = useRef(null);
const t5Ref = useRef(null);
const t6Ref = useRef(null);
const t7Ref = useRef(null);
const t8Ref = useRef(null);


useEffect(() => {
    const button = myBtnRef.current;
    const myLorem = myLoremRef.current;
                
    let colorTab = ["text-muted", "text-primary", "text-success", "text-info", "text-warning", "text-danger", "text-secondary", "text-white", "text-dark", "text-body", "text-light"];

    const handleClick = () => {
        myLorem.classList.remove(`${myClassOld.current}`);
        myClass.current = colorTab[Math.floor(Math.random() * colorTab.length)];
        console.log(myClass.current);
        myLorem.classList.add(`${myClass.current}`);
        myClassOld.current = myClass.current;
    };

    // Add event listener
    button.addEventListener('click', handleClick);

    // Cleanup on unmount
    return () => {
      button.removeEventListener('click', handleClick);
    };
  }, []);


useEffect(() => {

    let textBgPatternTab = ["text-bg-primary", "text-bg-success", "text-bg-info", "text-bg-warning", "text-bg-danger", "text-bg-secondary", "text-bg-dark", "text-bg-light"]; 
    let textBgCurrentTab = ["text-bg-primary", "text-bg-success", "text-bg-info", "text-bg-warning", "text-bg-danger", "text-bg-secondary", "text-bg-dark", "text-bg-light"]; 

    function changeTextBgPattern(){
        let textTab = [ t1Ref.current,
                        t2Ref.current,
                        t3Ref.current,
                        t4Ref.current,
                        t5Ref.current,
                        t6Ref.current,
                        t7Ref.current,
                        t8Ref.current
                    ]
        let patternIndextab = [];
        for (let index = 0; index < textBgPatternTab.length; index++) {
            if(textTab[index])
                textTab[index].classList.remove(textBgCurrentTab[index]);
            do{
                patternIndexRef.current = Math.floor(Math.random() * textBgPatternTab.length);
                //alert(patternIndex);
            }while(patternIndextab.includes(patternIndexRef.current))
            patternIndextab.push(patternIndexRef.current); // dodajemy wylosowany index patternu do tablicy
                                                // żeby nie losować go drugi raz
            myClass.current = textBgPatternTab[patternIndexRef.current];
            if(textTab[index])
                textTab[index].classList.add(myClass.current); 
            textBgCurrentTab[index] = myClass.current;
        }
    }

    // change every 1 seconds
    const intervalId = setInterval(changeTextBgPattern, 1000);

    // cleanup interval on unmount
    return () => clearInterval(intervalId);

  }, []);

  
  return (
    <div className="container-fluid mt-3">
        <div className="row">
            <div className="col-sm-3">
                <h1 className="display-1 text-center">Lorem ipsum </h1>
                <abbr title="Centrum Kształcenia Zawodowego i Ustawicznego w Łodzi">CKZiU</abbr><br />
                <span className="mark">dolor sit amet,</span><br /> 
                <dl>
                    <dt>consectetur adipiscing elit.</dt>
                    <dd>-  Sed quis purus nec enim venenatis dapibus.</dd>
                    <dt>Fusce sit amet nisl a libero ultricies vestibulum.</dt>
                    <dd>- Vestibulum rutrum turpis feugiat,</dd>
                </dl>    
                <code>semper tellus ut,</code>, <code>faucibus elit.</code>,<br />
                <kbd>Donec ullamcorper nisi  </kbd><br />
                <a href="#" className="text-decoration-none"> lacinia posuere semper.</a><span>// link</span><br />
                <p className="text-uppercase">Curabitur vitae dapibus dolor. </p> 
                <p className="text-capitalize">Maecenas rhoncus suscipit dui, in luctus risus congue id. Nulla iaculis lorem sit amet tempor ultrices. Sed ligula orci, efficitur ut tortor cursus, cursus volutpat arcu. Maecenas ut facilisis purus. Cras et condimentum arcu, vitae tempus turpis. Sed eget mi pharetra, bibendum metus ut, facilisis massa. Quisque viverra libero in velit porta lacinia. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Pellentesque feugiat, diam vel ullamcorper tempor, sem ipsum condimentum ligula, id sagittis nulla ipsum non nisi. Sed viverra mollis mauris accumsan pulvinar. Vestibulum ullamcorper vitae neque et imperdiet.
                </p>         
            </div>
            <div className="col-sm-3">
                <div className="block col-sm-12 bg-primary"></div>
                <div className="block col-sm-12 bg-success"></div>
                <div className="block col-sm-12 bg-info"></div>
                <div className="block col-sm-12 bg-light"></div>
                <div className="block col-sm-12 bg-warning"></div>
                <div className="block col-sm-12 bg-danger"></div>
                <div className="block col-sm-12 bg-secondary"></div>
                <div className="block col-sm-12 bg-dark"></div>
                
            </div>
            <div className="col-sm-3">
                <h1 ref={myLoremRef} id="lorem" className="display-1 text-center text-body">Lorem ipsum</h1>
                <p className="text-center"><button ref={myBtnRef} id = "btn" type="button" className="btn btn-success">change color</button></p>
            </div>
            <div className="col-sm-3">
                <h2>Background Color with Contrasting Text Color</h2>
                <p ref={t1Ref} className="text-bg-primary">This text is important.</p>
                <p ref={t2Ref} className="text-bg-success">This text indicates success.</p>
                <p ref={t3Ref} className="text-bg-info">This text represents some information.</p>
                <p ref={t4Ref} className="text-bg-warning">This text represents a warning.</p>
                <p ref={t5Ref} className="text-bg-danger">This text represents danger.</p>
                <p ref={t6Ref} className="text-bg-secondary">Secondary background color.</p>
                <p ref={t7Ref} className="text-bg-dark">Dark grey background color.</p>
                <p ref={t8Ref} className="text-bg-light">Light grey background color.</p>
            </div>
        </div>
    </div>
  );
}

